import MultiSelectDropdown from "./multiSelectDropdown";
import { MultiSelectDropdownSmartWrapperProps } from "./types";
import { FILE_TYPE_EXTENSION_MAP, FILE_TYPE_OPTIONS } from "../../utils/fileTypes";

type FileTypes = typeof FILE_TYPE_OPTIONS[number];

export const mapFileTypeToFileExtensions = (fileTypes: FileTypes[]) => {
    return ['fileExtensions', fileTypes.flatMap(t => FILE_TYPE_EXTENSION_MAP[t as keyof typeof FILE_TYPE_EXTENSION_MAP])];
}

interface FileTypeDropdownProps {
    dropdownProps: MultiSelectDropdownSmartWrapperProps<string, string>;
}

const FileTypeDropdown = ({
    dropdownProps,
}: FileTypeDropdownProps) => {


    const isLoading = false;


    return (
        <MultiSelectDropdown<string, string>
            label="File Type"
            options={FILE_TYPE_OPTIONS as string[]}
            selections={dropdownProps.selections ?? []}
            isLoading={isLoading}
            renderOption={(o) => o}
            onSearchTermChange={() => { }}
            enableSearch={false}
            mapOptionToSelection={(o) => o}
            {...dropdownProps}
        />
    );
}

export default FileTypeDropdown;
